import { IconType } from '@factorialco/f0-react'
import {
  Bank as BankIcon,
  Bell as BellIcon,
  BookOpen as BookOpenIcon,
  CheckCircleLine as CheckCircleLineIcon,
  Clock as ClockIcon,
  Folder as FolderIcon,
  Graph as GraphIcon,
  Megaphone as MegaphoneIcon,
  MessageHeart as MessageHeartIcon,
  MoneyBag as MoneyBagIcon,
  Money as MoneyIcon,
  PalmTree as PalmTreeIcon,
  Receipt as ReceiptIcon,
  SearchPerson as SearchPersonIcon,
  Suitcase as SuitcaseIcon,
  Wallet as WalletIcon,
} from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

type NotifierCategory =
  | 'Timeoff'
  | 'Attendance'
  | 'Ats'
  | 'Contracts'
  | 'Documents'
  | 'Esignature'
  | 'Expenses'
  | 'Banking'
  | 'Tasks'
  | 'Procurement'
  | 'Payroll'
  | 'Compensations'
  | 'IntegrationsDatevLauds'
  | 'BookkeepersManagement'
  | 'ProductUpdates'
  | 'Trainings'
  | 'ProjectManagement'
  | 'Processes'
  | 'Upsell'
  | 'Finance'
  | 'Performance'
  | 'Surveys'

export const getCategoryAndIcon = (notifier: string): { category: string; icon?: IconType } => {
  // eslint-disable-next-line no-type-assertion/no-type-assertion
  const firstPart = notifier.split('::')?.[0] as NotifierCategory

  switch (firstPart) {
    case 'Timeoff':
      return { category: i18n.t('sidebar.time_off'), icon: PalmTreeIcon }
    case 'Attendance':
      return { category: i18n.t('sidebar.clock_in'), icon: ClockIcon }
    case 'Ats':
      return { category: i18n.t('sidebar.recruitment'), icon: SearchPersonIcon }
    case 'Contracts':
      return { category: i18n.t('sidebar.contracts'), icon: BellIcon }
    case 'Documents':
    case 'Esignature':
      return { category: i18n.t('sidebar.documents'), icon: FolderIcon }
    case 'Expenses':
      return { category: i18n.t('sidebar.expenses_v2'), icon: MoneyBagIcon }
    case 'Banking':
      return { category: i18n.t('sidebar.finance_treasury'), icon: BankIcon }
    case 'Tasks':
    case 'Processes':
      return { category: i18n.t('tasks.header'), icon: CheckCircleLineIcon }
    case 'Procurement':
      return { category: i18n.t('sidebar.purchases'), icon: WalletIcon }
    case 'Payroll':
    case 'BookkeepersManagement':
    case 'IntegrationsDatevLauds':
      return { category: i18n.t('sidebar.payroll_bundle'), icon: MoneyIcon }
    case 'Compensations':
      return { category: i18n.t('sidebar.compensation'), icon: MoneyIcon }
    case 'ProductUpdates':
      return { category: i18n.t('sidebar.product_updates.news'), icon: MegaphoneIcon }
    case 'Trainings':
      return { category: i18n.t('sidebar.trainings'), icon: BookOpenIcon }
    case 'ProjectManagement':
      return { category: i18n.t('sidebar.projects_management'), icon: SuitcaseIcon }
    case 'Upsell':
      return { category: i18n.t('sidebar.marketplace'), icon: MegaphoneIcon }
    case 'Finance':
      return { category: i18n.t('sidebar.finance'), icon: ReceiptIcon }
    case 'Performance':
      return { category: i18n.t('sidebar.performance_new'), icon: GraphIcon }
    case 'Surveys':
      return { category: i18n.t('sidebar.engagement'), icon: MessageHeartIcon }
    default:
      return { category: i18n.t('common.unknown') }
  }
}

// Helper function to convert full URLs to relative paths for React Router
export const getRelativePath = (url: string): string => {
  try {
    const urlObj = new URL(url)
    return urlObj.pathname + urlObj.search + urlObj.hash
  } catch {
    // If URL parsing fails, assume it's already a relative path
    return url
  }
}
